
<div style="padding:20px">
  <button (click)="addBanner()" mat-stroked-button color="primary">新增輪播圖</button>

  <div *ngFor="let item of bannerList; let i = index" style="padding:10px;margin:10px;border:1px solid #bbb">
    <div style="display: inline-block; padding: 10px; width: 10%; vertical-align: top; text-align: center ">
      <span style="font-size:x-large;font-weight:bold">{{i+1}}</span>
    </div>
    <div style="display: inline-block; padding: 10px; width: 40%; vertical-align: top; text-align: center ">
      <input (change)="uploadFile($event, i)" #fileInput type="file" accept="image/*" style="margin:5px"><br />
      <img *ngIf="item.imgPath" style="width:80%" src="{{globalVar.targetIp}}/upload/{{item.imgPath}}"  />
    </div>
    <div style="display: inline-block; padding: 10px; width: 40%; vertical-align: top ">
      <input [(ngModel)]="item.imgLink" style="width:95%;font-size:medium;padding:3px 7px" />
    </div>
    <div style="display: inline-block; padding: 10px; width: 10%; vertical-align: top; text-align: center ">
      <button (click)="deleteBanner(i)" mat-stroked-button color="warn">刪除</button>
    </div>
  </div>
  <div style="text-align:center">
    <button *ngIf="bannerList.length > 0" (click)="saveBanner()" mat-stroked-button color="primary" style="font-weight:bold;width:300px">儲存</button>
  </div>
</div>

